import { useThemeStore } from "@stores/theme.store";
import moment from "moment-timezone";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
moment.locale("id");
export const TahfidzRekapDetailPage = () => {
  const { state } = useLocation();
  const { setHeader, setAppBar } = useThemeStore((state) => state);

  useEffect(() => {
    setAppBar({ title: "Detail Rekap", show: true, leading: "back" });
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Detail Rekap",
    });
  }, [setHeader, setAppBar]);

  return (
    <>
      <div className="tw-px-4 tw-pb-20">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-primary-hg tw-text-xs">Wali Halaqoh</div>
          <div className="tw-mb-3">{state.waliHalaqoh ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Bulan</div>
          <div className="tw-mb-3">
            {moment(state.bulan ?? Date.now()).format("MMMM YYYY")}
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Total Hafalan</div>
          <div className="tw-mb-3">
            {state.totalHalaman ?? "0"} halaman ({state.totalHafalan ?? "0"}{" "}
            juz)
          </div>

          <div className="tw-text-primary-hg tw-text-xs">Jenis</div>
          <div className="tw-mb-3">{state.jenis ?? "-"}</div>

          <div className="tw-text-primary-hg tw-text-xs">Keterangan</div>
          <div className="tw-mb-3 tw-font-semibold">
            {(state.jenis === "Reguler" && parseInt(state.totalHalaman) >= 8) ||
            (state.jenis === "Syu'bah Tahfizh" &&
              parseInt(state.totalHalaman) >= 20)
              ? "Tercapai"
              : "Belum Tercapai"}
          </div>
        </div>
      </div>
    </>
  );
};
